import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Opera } from "../../types"
import { useOperaCreate } from "../../hooks/opere"
import OperaForm from "./OperaForm"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesOpera, validationSchemaOpera } from "./OperaCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function OpereCreate() {
  const createOpera = useOperaCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Opere", href: "/opere/opere" }, { label: "Creazione Opera" }])

  const initialValues = useMemo(() => initialValuesOpera(), [])
  const validationSchema = useMemo(() => validationSchemaOpera(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova Opera</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createOpera.mutateAsync(values as Opera).then((opera) => {
                navigate(`/opere/opere/${opera.id}/dettaglio`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <OperaForm />
                </Container>
                <BottomFormFixed url="/opere/opere" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
